"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _emotion = require("emotion");

var _react = _interopRequireDefault(require("react"));

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

var _dateFns = require("date-fns");

var _utils = require("../SQONView/utils");

var _AggsWrapper = _interopRequireDefault(require("./AggsWrapper"));

require("react-datepicker/dist/react-datepicker.css");

require("./DatesAgg.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dateFromSqon = function dateFromSqon(dateString) {
  return new Date(dateString);
};

var toSqonDate = function toSqonDate(date) {
  return date.valueOf();
};

var DatesAgg = /*#__PURE__*/function (_React$Component) {
  _inherits(DatesAgg, _React$Component);

  var _super = _createSuper(DatesAgg);

  function DatesAgg(props) {
    var _this;

    _classCallCheck(this, DatesAgg);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "initializeState", function (_ref) {
      var _ref$stats = _ref.stats,
          stats = _ref$stats === void 0 ? {} : _ref$stats,
          _ref$getActiveValue = _ref.getActiveValue,
          getActiveValue = _ref$getActiveValue === void 0 ? function () {
        return null;
      } : _ref$getActiveValue;
      var field = _this.props.field;
      var minDate = stats.min && (0, _dateFns.subDays)(stats.min, 1);
      var maxDate = stats.max && (0, _dateFns.addDays)(stats.max, 1);
      var startFromSqon = getActiveValue({
        op: '>=',
        field: field
      });
      var endFromSqon = getActiveValue({
        op: '<=',
        field: field
      });
      return {
        minDate: minDate,
        maxDate: maxDate,
        startDate: startFromSqon ? dateFromSqon(startFromSqon) : null,
        endDate: endFromSqon ? dateFromSqon(endFromSqon) : null
      };
    });

    _defineProperty(_assertThisInitialized(_this), "updateSqon", function () {
      var _this$state = _this.state,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate;
      var _this$props = _this.props,
          field = _this$props.field,
          handleDateChange = _this$props.handleDateChange;

      if (handleDateChange && field) {
        var content = [].concat(_toConsumableArray(startDate ? [{
          op: '>=',
          content: {
            field: field,
            value: toSqonDate((0, _dateFns.startOfDay)(startDate))
          }
        }] : []), _toConsumableArray(endDate ? [{
          op: '<=',
          content: {
            field: field,
            value: toSqonDate((0, _dateFns.endOfDay)(endDate))
          }
        }] : []));
        handleDateChange({
          field: field,
          value: content,
          generateNextSQON: function generateNextSQON(sqon) {
            return (0, _utils.replaceSQON)(content.length ? {
              op: 'and',
              content: content
            } : null, (0, _utils.removeSQON)(field, sqon));
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDateChange", function (limit) {
      return function (date) {
        _this.setState(_defineProperty({}, "".concat(limit, "Date"), date), _this.updateSqon);
      };
    });

    _this.state = _this.initializeState(props);
    return _this;
  }

  _createClass(DatesAgg, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState(this.initializeState(nextProps));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$collapsi = _this$props2.collapsible,
          collapsible = _this$props2$collapsi === void 0 ? true : _this$props2$collapsi,
          _this$props2$displayN = _this$props2.displayName,
          displayName = _this$props2$displayN === void 0 ? 'Date Range' : _this$props2$displayN,
          _this$props2$facetVie = _this$props2.facetView,
          facetView = _this$props2$facetVie === void 0 ? false : _this$props2$facetVie,
          field = _this$props2.field,
          type = _this$props2.type,
          WrapperComponent = _this$props2.WrapperComponent;
      var _this$state2 = this.state,
          minDate = _this$state2.minDate,
          maxDate = _this$state2.maxDate,
          startDate = _this$state2.startDate,
          endDate = _this$state2.endDate;

      var dataFields = _objectSpread(_objectSpread({}, field && {
        'data-field': field
      }), type && {
        'data-type': type
      });

      return /*#__PURE__*/_react["default"].createElement(_AggsWrapper["default"], {
        dataFields: dataFields,
        displayName: displayName,
        WrapperComponent: WrapperComponent,
        collapsible: collapsible
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _emotion.css)( /*#__PURE__*/(0, _emotion.css)("align-items:center;display:flex;justify-content:space-around;padding-left:5px;"))
      }, /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
        minDate: minDate,
        maxDate: maxDate,
        "aria-label": "Pick start date",
        className: "start-date",
        isClearable: true,
        onChange: this.handleDateChange('start'),
        openToDate: startDate || minDate,
        placeholderText: "YYYY/MM/DD",
        popperPlacement: facetView ? 'bottom-start' : 'top-start',
        selected: startDate
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _emotion.css)( /*#__PURE__*/(0, _emotion.css)("font-size:13px;margin:0 10px;"))
      }, "to"), /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
        minDate: minDate,
        maxDate: maxDate,
        "aria-label": "Pick end date",
        className: "end-date",
        isClearable: true,
        onChange: this.handleDateChange('end'),
        openToDate: endDate || maxDate,
        placeholderText: "YYYY/MM/DD",
        popperPlacement: facetView ? 'bottom-end' : 'top-start',
        selected: endDate
      })));
    }
  }]);

  return DatesAgg;
}(_react["default"].Component);

var _default = DatesAgg;
exports["default"] = _default;